import APIService from "./APIService";

const RiskAssessmentAPI = {
  calculateUserRisk: async () => {
    try {
      const response = await APIService.post(
        `/api/v1/app/risk-assessment/users/calculate`
      );
      console.log(
        `[RiskAssessmentAPI] Calculate user risk response:`,
        response
      );
      return response;
    } catch (error) {
      console.error("[RiskAssessmentAPI] Error calculating user risk:", error);
      throw error;
    }
  },

  getLatestUserRisk: async () => {
    try {
      const response = await APIService.get(
        `/api/v1/app/risk-assessment/users/latest`
      );
      console.log(
        `[RiskAssessmentAPI] Get latest user risk response:`,
        response
      );
      return response;
    } catch (error) {
      console.error(
        "[RiskAssessmentAPI] Error getting latest user risk:",
        error
      );
      throw error;
    }
  },

  getUserGroupRiskScores: async () => {
    try {
      const response = await APIService.get(
        `/api/v1/app/risk-assessment/users/group-risk-scores`
      );
      console.log(
        `[RiskAssessmentAPI] Get user group risk scores response:`,
        response
      );
      return response;
    } catch (error) {
      console.error(
        "[RiskAssessmentAPI] Error getting user group risk scores:",
        error
      );
      throw error;
    }
  },
};

export default RiskAssessmentAPI;
